import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
 import CreateOffline from "../../images/createOffline.png"

function OfflineOrders() {
  const OfflineOrdersDoc = {
    title: "Offline Orders",
    description: "Learn how to efficiently manage and process offline orders.",
    sections: [
      {
        title: "Overview",
        content: "Manual for managing offline orders.",
      },
  
      // Documentation for recording offline orders
      {
        title: "Record an Offline Order",
        content: "Steps to manually record offline orders.",
        image: CreateOffline,
        imageAlt: "Record Offline Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of the Record Offline Dashboard",
        subsections: [
          {
            title: "How to Record an Offline Order",
            content:
              "You can easily filter express orders from the main order list.",
            steps: [
              "Ensure the file is uploaded in CSV or Excel format.",
              "The file must contain the following columns: Product SKU, Customer Phone, Customer Name, Order Total Amount, Reseller Phone Number, Quantity, Reseller Profit, Delivery Location ID, Delivery Amount, Customer Area, Customer City.",
              "The first row of the file must include the column names.",
              "The file must contain at least one row of data.",
              "Refer to the Delivery Locations Tab for the Delivery Location ID.",
            ],
          },
        ],
      },
  
      // Documentation for orders created offline
      {
        title: "Orders Created Offline",
        content:
          "A list of all orders created offline for further manipulation.",
        subsections: [
          {
            title: "Change Status",
            content: "Change the status of orders and add notes.",
            steps: [
              "Search for each order by its ID (e.g., 20243-6234322-672).",
              "Change the status of orders (e.g., pending, accepted, etc.).",
              "ADD NOTES: Each order has functionality to add notes.",
              "UPDATE ORDER: After changing the order status or adding a note, click on Update Order to submit the changes.",
            ],
          },
          {
            title: "Edit Orders",
            content:
              "Ensure offline orders are processed swiftly to meet delivery deadlines.",
            steps: [
              "EDIT CUSTOMER LOCATION: Click 'Add Location' to update the customer's location.",
              "EDIT CUSTOMER NUMBER: Click 'Edit Customer Phone' to update the customer's phone number.",
              "EDIT ORDER AMOUNT: Use the plus and minus signs to adjust the number of items ordered.",
              "CHANGE DELIVERY LOCATION: Modify the delivery location; note that this may affect delivery costs.",
              "UPDATE ORDER: Click 'Update Order' to submit your changes.",
            ],
            note: "Remember: Prompt processing of orders is crucial.",
          },
  
          {
            title: "More Operations",
            content: "Additional actions available for each order.",
            steps: [
              "VIEW CART",
              "EDIT SKU",
              "ADD NOTES",
              "DELIVERY MESSAGE",
              "PICKUP MESSAGE",
            ],
            note: "Remember: Efficient management of orders is essential.",
          },
        ],
      },
  
      // Documentation for orders that failed to create offline
      {
        title: "Failed to Create Offline Orders",
        content:
          "Manage a list of all failed orders and the actions to take for each.",
        subsections: [
          {
            title: "Remove Failed Orders",
            content: "Steps to remove failed orders from the list.",
            steps: [
              "To remove a failed order, click the checkbox next to the order and confirm the removal when prompted.",
            ],
          },
        ],
      },
    ],
  };
  

  return <FeatureDocumentation {...OfflineOrdersDoc} />;
}

export default OfflineOrders;
